import styled from "@emotion/styled";
import { Card, Stack } from "react-bootstrap";
import { DEFAULT_CARD_STYLES } from "../../../shared/styles/Card.styles";
import { IStyledComponentProps } from "../../../theme/theme.types";

const NotificationsCard = styled(Card)<IStyledComponentProps>`
  &.notifications-card {
    ${DEFAULT_CARD_STYLES}
  }
`;

const NotificationListItem = styled(Stack)<IStyledComponentProps>`
  &.notification-stack-item {
    margin: 0 16px;
    padding: 8px 0;
    border-bottom: 1px solid ${({ theme }) => theme.colors.grays.tertiary};

    .type,
    .id {
      font-size: 11px;
    }
    .description {
      font-family: ${({ theme }) => theme.fontFamilies.semiBold};
      font-size: 18px;
    }

    // Note: Need to keep this around, since we need to use
    // bootstraps badge component when there are tool-tips needed
    // for the badge
    .badge {
      border-radius: 0;
      width: 72px;
      font-size: 11px;
      font-family: ${({ theme }) => theme.fontFamilies.semiBold};
      padding: 6px 0;

      @media (min-width: ${(props) =>
          props.theme.utils.getThemeBreakpoint("tablet")}) {
        &.badge-tooltip {
          &:hover {
            cursor: pointer;
          }
        }
      }
    }

    &:last-child {
      border: 0 none;
    }

    @media (max-width: ${(props) =>
        props.theme.utils.getThemeBreakpoint("tablet")}) {
      margin: 0;
    }
  }
`;

export default { NotificationsCard, NotificationListItem };
